import React from 'react';
import { Icon, Table as SemanticTable } from "semantic-ui-react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Table, TimestampFilters } from 'dyl-components';

import { getData, onToggleTimeUnit, useRangeCalendar } from 'shared/CustomDateRange/customDateRange';

const SortActions = ({ direction = false, onToggleSort = () => { } }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};

const SequenceTableHeader = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    const createdOrder = params.get("order_by") === "created" && params.get("order") === "asc";

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };

    const createdOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !createdOrder ? "asc" : "desc";
        query.set("order", order);
        query.set("order_by", "created");
        const query_string = query.toString();
        navigate(`/settings/sequences${query_string ? `?${query_string}` : ""}`);
    };

    return (
        <Table.Row isHeader>
            <SemanticTable.HeaderCell width={2}>
                <span style={{ marginRight: 5 }}>Created</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            "/settings/sequences"
                        )
                    }
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => {
                        setCustomDateRangeOpen(true);
                    }}
                    onCloseCustomDateRange={() => {
                        setCustomDateRangeOpen(false);
                    }}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url: "/settings/sequences",
                        })
                    }
                />

                <SortActions
                    direction={createdOrder}
                    onToggleSort={() => {
                        createdOrderFilter();
                    }}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Sequence Name</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Description</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>Assigned Territories/Name</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Created By</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={1}>Actions</SemanticTable.HeaderCell>
        </Table.Row>
    );
}

export default SequenceTableHeader;
